import React, { useContext } from 'react';
import ChevronGray from '../../../../../Assets/StorefrontIcons/ChevronGray.svg';
import YellowAlert from '../../../../../Assets/StorefrontIcons/YellowAlert.svg';
import { useDispatch } from 'react-redux';
import { setSelectedCarouselBannerSection } from '../../../../../Features/storefrontSlice';
import ImageInput from './ImageInput';
import Links from './Links';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function BannerSection({ banner, isFirst, isSelected, isActive, hasAlert }) {
    const dispatch = useDispatch();

    const {
        setCarouselBanner
    } = useContext(StorefrontContext);

    function handleSelectBannerSection() {
        if(isActive) {
            dispatch(setSelectedCarouselBannerSection(banner.title));
        }
        else {
            showToast('Can\'t select this banner.', 'warning');
        }
    }

    function handleChange(e) {
        setCarouselBanner((prevCarouselBanner) =>
            prevCarouselBanner.map((item) =>
                item.title === banner.title
                    ? { ...item, altText: e.target.value } 
                    : item
            )
        );
    }

    return (
        <div className="flex flex-col">
            <button onClick={handleSelectBannerSection} className={`outline-none bg-[#FFFFFF] ${isSelected && 'bg-[#FAFAFA]'} hover:bg-[#FAFAFA] ${!isFirst && 'border-t border-[#EAEAEA]'} p-3 flex items-center justify-between`}>
                <div className="flex items-center gap-2">
                    <p className={`font-medium text-base ${isActive ? 'text-[#000000]' : 'text-[#666666]'}`}>{banner.title}</p>                    

                    {
                        hasAlert && 
                        <div className="size-4">
                            <img className='size-full' src={YellowAlert} alt="" />
                        </div>
                    }
                </div>

                <div className={`size-6 flex items-center justify-center transition-all duration-300 ease-linear ${isSelected ? '' : '-rotate-90'}`}>
                    <img className={`${!isActive && 'opacity-50'}`} src={ChevronGray} alt="" />
                </div>
            </button>

            {
                isSelected && 
                <div className="flex flex-col gap-3 p-3">
                    <ImageInput 
                        banner={banner} 
                        image={banner.image} 
                    />

                    <div className="flex flex-col gap-2">
                        <div className="flex items-center justify-between">
                            <label className='font-medium text-[14px] leading-6 text-[#121212] cursor-pointer' htmlFor="alt-text">Alt Text</label>

                            {/* <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.altText}</p> */}
                        </div>

                        <textarea 
                            className='outline-none h-24 border border-[#EAEAEA] bg-[#F5F5F5] p-3 rounded-[9px] font-normal text-[12px] leading-6 text-[#121212] placeholder:text-[#666666]' 
                            name="alt-text" 
                            id="alt-text" 
                            placeholder='Describe your image for people with visual impairments' 
                            value={banner.altText} 
                            onChange={handleChange} 
                        />
                    </div>

                    <Links 
                        link={banner.link} 
                    />
                </div>
            }
        </div>
    );
}

export default BannerSection;
